import { useContext, createContext } from "react";

export type ListViewStyle = "list" | "grid";
export type CartDropdownView = "cart" | "clientChooser";

export interface AppContextType {
  preferredListViewStyle: ListViewStyle;
  changeListViewStyle: (v: ListViewStyle) => void;
  cartDropdownView: CartDropdownView;
  toggleCartDropdownView: (v?: CartDropdownView) => void;
}

export const Context = createContext<AppContextType | undefined>({
  changeListViewStyle: () => {},
  preferredListViewStyle: "list",
  cartDropdownView: "cart",
  toggleCartDropdownView: () => {},
});

const useAppContext = () => {
  const ctx = useContext(Context);
  if (!ctx)
    throw new Error("useAppContext must be used within AppContextProvider");
  return ctx;
};

export default useAppContext;
